package com.vizio.redwolf.m2m.model

import kotlinx.serialization.Serializable
import kotlin.js.JsExport

@Serializable
@JsExport
data class M2MTokenResponse(
    val accessToken: String,
    val expiresIn: Long? = null,
    val tokenType: String? = null
)